import { render, staticRenderFns } from "./place_recommendations.vue?vue&type=template&id=3dbc829a&scoped=true&"
import script from "./place_recommendations.vue?vue&type=script&lang=js&"
export * from "./place_recommendations.vue?vue&type=script&lang=js&"
import style0 from "./place_recommendations.vue?vue&type=style&index=0&id=3dbc829a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbc829a",
  null
  
)

export default component.exports